<template>
  <div class="PacientesListado">
    <md-table md-card>
      <md-table-toolbar>
        <div class="md-toolbar-section-start md-title">Pacientes</div>
        <div class="md-toolbar-section-end">
          <md-field md-clearable>
            <md-input
              placeholder="Buscar paciente..."
              v-model="buscar"
            />
          </md-field>
          <md-button
            class="md-icon-button"
            to="/paciente"
          >
            <md-icon v-text="'add'" />
          </md-button>
          <md-button
            v-if="this.$session.get('tipo') === 'administrativo'"
            class="md-icon-button"
            @click="$doCSV(filtro_pacientes,'pacientes')"
          >
            <md-icon v-text="'cloud_download'" />
          </md-button>
        </div>
      </md-table-toolbar>
      <md-table-row>
        <md-table-head>Nombre</md-table-head>
        <md-table-head>Sexo</md-table-head>
        <md-table-head>Edad</md-table-head>
        <md-table-head v-if="showEscuela">Escuela</md-table-head>
      </md-table-row>
      <md-table-row
        class="upper"
        v-for="(item,i) in filtro_pacientes"
        :key="i"
      >
        <md-table-cell>{{ `${item.nombre_pac}  ${item.ape_pat_pac} ${item.ape_mat_pac}` }}</md-table-cell>
        <md-table-cell>{{item.sexo_pac }}</md-table-cell>
        <md-table-cell>{{item.fecha_nac_pac}}</md-table-cell>
        <md-table-cell v-if="showEscuela">{{item.nombre_esc }}</md-table-cell>
        <!-- <md-table-cell> <md-button class="md-dense">Tamizar</md-button> </md-table-cell> -->
      </md-table-row>
    </md-table>
    <Loading v-if="cargando" />
  </div>
</template>

<script>
const toLower = text => {
  return text.toString().toLowerCase();
};
const buscarPac = (items, term) => {
  if (term) {
    let terlow = toLower(term);
    return items.filter(
      item =>
        toLower(item.nombre_pac).includes(terlow) ||
        toLower(item.sexo_pac).includes(terlow) ||
        toLower(item.fecha_nac_pac).includes(terlow)
    );
  }
  return items;
};

import Loading from "@/components/Loading";
export default {
  name: "PacientesListado",
  components: { Loading },
  methods: {
    buscarEnLaTabla() {
      this.filtro_pacientes = buscarPac(this.pacientes, this.buscar);
    },
    _falloResponse(err) {
      this.cargando = false;
      if (err.status === 401) {
        this.$router.push("/login");
      } else {
        this.$emit("msg", this.$no_internet);
      }
    },
    _getPacientes() {
      this.cargando = true;
      this.$http.get("pacientes", this.$headers).then(
        res => {
          this.cargando = false;
          if (res.status === 401) {
            this.$router.push("/login");
          } else if (res.status === 200 && "pacientes" in res.body) {
            this.pacientes = res.body.pacientes;
            this.filtro_pacientes = res.body.pacientes;
          } else {
            this.$emit("msg", res.body.error);
          }
        },
        err => this._falloResponse(err)
      );
    }
  },
  data() {
    return {
      cargando: false,
      buscar: null,
      pacientes: [],
      filtro_pacientes: [],
      showEscuela: false
    };
  },
  watch: {
    buscar(a) {
      this.buscarEnLaTabla();
    }
  },
  mounted() {
    if (this.$session.get("tipo") === "administrativo" && this.isOnline) {
      this.showEscuela = true;
      this._getPacientes();
    } else {
      this.showEscuela = false;
      if (localStorage.getItem("pacientes")) {
        this.pacientes = JSON.parse(localStorage.getItem("pacientes"));
        this.filtro_pacientes = this.pacientes;
      }
    }
  },
  beforeDestroy() {},
  beforeCreate() {
    if (!this.$session.exists()) {
      this.$emit("visible", false);
      this.$router.push("/login");
    } else {
      this.$emit("visible", true);
      this.$emit("classes", "container");
    }
  }
};
</script>
